import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Sempre que a rota mudar, rola para o topo.
 * Útil quando o usuário navega entre Home e páginas de Ministérios.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Permite que âncoras (#sobre, #contato, etc.) funcionem normalmente.
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}
